import Handlebars from 'handlebars/dist/cjs/handlebars';
import { API_PATH } from '../../constants';
import axios from 'axios';
import '../../utils/handlebars-asset';

(() => {
  const selectors = {
    hbsSource: 'hbs-template__js',
    hbsTemplate: 'hbs-template',
    wrapper: '.template',
    btnMore: '.btn-more-regions',
    select: 'select-state',
    currentUF: 'title-list__uf'
  };

  const cssClasses = {
    loading: 'is-loading',
    firstLoad: 'is-first-load'
  };

  let indexPage = 1;
  let totalPages = 1;
  const limit = 12;
  const arrRegions = { regions: [] };
  const source = document.getElementById(selectors.hbsSource).innerHTML;
  const template = Handlebars.compile(source);

  function getRegions(state, page = 1) {
    isLoading(true);

    axios.get(`${API_PATH}/${state}/regions`, {
      params: {
        page: page,
        limit: limit
      }
    })
      .then((response) => {
        if (response.data.success) {
          const data = response.data.data;

          // console.log('DATA', response.data);

          data.map((region) => arrRegions.regions.push(region));
          document.getElementById(selectors.hbsTemplate).innerHTML = template(arrRegions);

          isLoading(false);
          renderPagination(response.data.page, response.data.total, limit);
        } else {
          isLoading(false);
          console.log('GET Error ->', response.data.message);
        }
      })
      .catch((error) => {
        isLoading(false);
        console.warn('GET Error', error);
      });
  }

  function isLoading(bool) {
    if (bool) {
      document.getElementById(selectors.select).disabled = true;
      document.getElementById(selectors.hbsTemplate).classList.add(cssClasses.loading);
      document.querySelector(selectors.btnMore).classList.add(cssClasses.loading);
    } else {
      if (document.querySelector(selectors.wrapper).classList.contains(cssClasses.firstLoad)) {
        document.querySelector(selectors.wrapper).classList.remove(cssClasses.firstLoad);
      }

      document.getElementById(selectors.select).disabled = false;
      document.getElementById(selectors.hbsTemplate).classList.remove(cssClasses.loading);
      document.querySelector(selectors.btnMore).classList.remove(cssClasses.loading);
    }
  };

  function renderPagination(index, totalItems, limitPerPage) {
    indexPage = parseInt(index, 10);
    totalPages = totalItems > 0 ? Math.ceil(totalItems / limitPerPage) : 0;

    if (totalPages > indexPage) {
      renderPaginationButton(true);
    } else {
      renderPaginationButton(false);
    }
  };

  function renderPaginationButton(bool) {
    if (bool) {
      document.querySelector(selectors.btnMore).disabled = false;
      document.querySelector(selectors.btnMore).style.display = 'block';
    } else {
      document.querySelector(selectors.btnMore).disabled = true;
      document.querySelector(selectors.btnMore).style.display = 'none';
    }
  }

  document.getElementById(selectors.select).addEventListener('change', (evt) => {
    const uf = evt.target.selectedOptions[0].text;

    arrRegions.regions = [];
    document.getElementById(selectors.currentUF).innerHTML = uf;
    getRegions(evt.target.value);
  });

  document.querySelector(selectors.btnMore).addEventListener('click', () => {
    getRegions(`${window.state.toLowerCase()}`, ++indexPage);
  });

  getRegions(window.state);

})();
